import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import cta from '../assets/cta.webm'
import { PENDING_SCORES_KEY, CACHED_LEADERBOARD_KEY } from '../utils/offlineScores'

const Home = () => {
  const navigate = useNavigate()
  const { level } = useDispatch()

  useEffect(() => {
    const kioskId = localStorage.getItem('kiosk-id')

    const preservedKeys = [
      'kiosk-id',
      PENDING_SCORES_KEY,
      CACHED_LEADERBOARD_KEY,
      'leaderboardLastUpdated',
    ]
    const preservedEntries = preservedKeys.reduce((acc, key) => {
      const value = localStorage.getItem(key)
      if (value !== null) {
        acc[key] = value
      }
      return acc
    }, {})

    localStorage.clear()

    Object.entries(preservedEntries).forEach(([key, value]) => {
      localStorage.setItem(key, value)
    })

    if (!localStorage.getItem('kiosk-id') && kioskId) {
      localStorage.setItem('kiosk-id', kioskId)
    }

    level.reset()
  }, [level])

  return (
    <div  
      onClick={() => navigate('/instructions')}
      className="w-full h-full overflow-hidden cursor-pointer"
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover z-[99]"
      >
        <source src={cta} type="video/webm" />
      </video>
    </div>
  )
}

export default Home
